"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = resolveRenderArgs;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _getIteratorMethod2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/get-iterator-method"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _awaitAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/awaitAsyncGenerator"));

var _wrapAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/wrapAsyncGenerator"));

var _asyncIterator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncIterator"));

var _HttpError = _interopRequireDefault(require("../HttpError"));

function _createForOfIteratorHelperLoose(o) { var _context5; var i = 0; if (typeof _symbol["default"] === "undefined" || (0, _getIteratorMethod2["default"])(o) == null) { if ((0, _isArray["default"])(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = (0, _getIterator2["default"])(o); return (0, _bind["default"])(_context5 = i.next).call(_context5, i); }

function _unsupportedIterableToArray(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = (0, _slice["default"])(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function foldElements(elementsRaw, routeIndices) {
  var elements = [];

  for (var _iterator2 = _createForOfIteratorHelperLoose(routeIndices), _step2; !(_step2 = _iterator2()).done;) {
    var routeIndex = _step2.value;

    if (typeof routeIndex === 'object') {
      (function () {
        var _context;

        // Reshape the next elements in the elements array to match the nested
        // tree structure corresponding to the route groups.
        var groupElements = {};
        (0, _forEach["default"])(_context = (0, _entries["default"])(routeIndex)).call(_context, function (_ref) {
          var groupName = _ref[0],
              groupRouteIndices = _ref[1];
          groupElements[groupName] = foldElements(elementsRaw, groupRouteIndices);
        });
        elements.push(groupElements);
      })();
    } else {
      // We intentionally modify elementsRaw, to make it easier to recursively
      // handle groups.
      elements.push(elementsRaw.shift());
    }
  }

  return elements;
}

function resolveRenderArgs(_x, _x2) {
  return _resolveRenderArgs.apply(this, arguments);
}

function _resolveRenderArgs() {
  _resolveRenderArgs = (0, _wrapAsyncGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(router, _ref2) {
    var match, matchContext, resolver, routes, augmentedMatch, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _context2, elements;

    return _regenerator["default"].wrap(function _callee$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            match = _ref2.match, matchContext = _ref2.matchContext, resolver = _ref2.resolver;
            routes = router.matcher.getRoutes(match);
            augmentedMatch = (0, _extends2["default"])({}, match, {
              routes: routes,
              router: router,
              // Convenience access for route components.
              context: matchContext
            });

            if (routes) {
              _context3.next = 7;
              break;
            }

            _context3.next = 6;
            return (0, _extends2["default"])({}, augmentedMatch, {
              error: new _HttpError["default"](404)
            });

          case 6:
            return _context3.abrupt("return");

          case 7:
            _context3.prev = 7;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context3.prev = 10;
            _iterator = (0, _asyncIterator2["default"])(resolver.resolveElements(augmentedMatch));

          case 12:
            _context3.next = 14;
            return (0, _awaitAsyncGenerator2["default"])(_iterator.next());

          case 14:
            _step = _context3.sent;
            _iteratorNormalCompletion = _step.done;
            _context3.next = 18;
            return (0, _awaitAsyncGenerator2["default"])(_step.value);

          case 18:
            _value = _context3.sent;

            if (_iteratorNormalCompletion) {
              _context3.next = 26;
              break;
            }

            elements = _value;
            _context3.next = 23;
            return (0, _extends2["default"])({}, augmentedMatch, {
              elements: elements && foldElements((0, _concat["default"])(_context2 = []).call(_context2, elements), match.routeIndices)
            });

          case 23:
            _iteratorNormalCompletion = true;
            _context3.next = 12;
            break;

          case 26:
            _context3.next = 32;
            break;

          case 28:
            _context3.prev = 28;
            _context3.t0 = _context3["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 32:
            _context3.prev = 32;
            _context3.prev = 33;

            if (!(!_iteratorNormalCompletion && _iterator["return"] != null)) {
              _context3.next = 37;
              break;
            }

            _context3.next = 37;
            return (0, _awaitAsyncGenerator2["default"])(_iterator["return"]());

          case 37:
            _context3.prev = 37;

            if (!_didIteratorError) {
              _context3.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context3.finish(37);

          case 41:
            return _context3.finish(32);

          case 42:
            _context3.next = 51;
            break;

          case 44:
            _context3.prev = 44;
            _context3.t1 = _context3["catch"](7);

            if (!_context3.t1.isFoundHttpError) {
              _context3.next = 50;
              break;
            }

            _context3.next = 49;
            return (0, _extends2["default"])({}, augmentedMatch, {
              error: _context3.t1
            });

          case 49:
            return _context3.abrupt("return");

          case 50:
            throw _context3.t1;

          case 51:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee, null, [[7, 44], [10, 28, 32, 42], [33,, 37, 41]]);
  }));
  return _resolveRenderArgs.apply(this, arguments);
}

module.exports = exports.default;